<script>
    import { _ } from "svelte-i18n";
    import { courses } from "../../stores";
    import Card from "./Card.svelte";
    import { Link } from "svelte-routing";
    import Icon from "fa-svelte";
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import { v4 as uuid } from "uuid";
</script>

<style>
    .grid {
        grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
    }
</style>

<div class="p-4 flex flex-col">
    {#if $courses}
        <div class="mb-4 self-end">
            <Link to={`/courses/${uuid()}`}>
                <button class="flex items-center space-x-2">
                    <span>{$_('Create')}</span>
                    <Icon icon={faPlus} />
                </button>
            </Link>
        </div>
    {/if}
    {#if $courses && $courses.length}
        <div class="p-4 grid gap-8 justify-center">
            {#each $courses as course}
                <slot {course}>
                    <Card {course} />
                </slot>
            {/each}
        </div>
    {:else}
        <div class="flex flex-col items-center">
            <h1>{$_('NothingHereYet')}</h1>
            <p class="text-6xl">🤷</p>
        </div>
    {/if}
</div>
